import $ from "jquery";
var calculator = function () {
    var $calculator = $(this);
    var $input = $calculator.find("input");
    var inputVal = undefined;
    var $select = $calculator.find("select");
    var selectVal = undefined;
    $input.off("input");
    $input.on("input", function () {
        var $err = $input.next("#input-err");
        var value = $input.val();
        var min = $input.attr("min");
        var max = $input.attr("max");
        $err.hide();
        if (value !== undefined && min !== undefined && max !== undefined) {
            var valueInt = parseInt(value.toString());
            var minInt = parseInt(min.toString());
            var maxInt = parseInt(max.toString());
            if (valueInt < minInt || valueInt > maxInt) {
                $err.show();
                reRenderResult($calculator);
            }
            else {
                inputVal = valueInt;
                if (selectVal !== undefined) {
                    calculate($calculator, inputVal, selectVal);
                }
            }
        }
    });
    $select.off("change");
    $select.on("change", function () {
        var value = $select.val();
        if (value !== undefined) {
            var valueFloat = parseFloat(value.toString());
            selectVal = valueFloat;
            if (inputVal !== undefined) {
                calculate($calculator, inputVal, selectVal);
            }
        }
    });
};
var calculate = function ($calculator, inputVal, selectVal) {
    var availableTokens = 155720833;
    var XIXOIOOwnedTokens = 66737497;
    var totalTokens = availableTokens + XIXOIOOwnedTokens;
    var targetValue2025 = 29000000;
    var tokenCommitment = targetValue2025 * 0.25;
    var singleTokenValue = tokenCommitment / totalTokens;
    var tokenCount = inputVal / selectVal;
    // const yield2025 = (tokenCount * singleTokenValue) + 6500;
    var yield2025 = inputVal * 0.065 + singleTokenValue * tokenCount;
    var pa = inputVal * 0.065;
    var pa2025 = (yield2025 / inputVal) * 100;
    // const pa2025 = ((pa + yield2025) / inputVal) * 100;
    var pa232425 = pa * 3;
    var ebitda2023 = 12000000;
    var ebitda2024 = 17000000;
    var ebitda2025 = 29000000;
    var ebitda25percent = (ebitda2023 + ebitda2024 + ebitda2025) * 0.25;
    var perToken = ebitda25percent / totalTokens;
    var fromEbitda = perToken * tokenCount;
    var yieldTotal = pa232425 + fromEbitda;
    var shareIncrease = (yieldTotal / inputVal) * 100;
    reRenderResult($calculator, tokenCount, yield2025, pa2025, yieldTotal, shareIncrease);
};
var reRenderResult = function ($calculator, tokenCount, yield2025, pa2025, yieldTotal, shareIncrease) {
    if (tokenCount === void 0) { tokenCount = 0; }
    if (yield2025 === void 0) { yield2025 = 0; }
    if (pa2025 === void 0) { pa2025 = 0; }
    if (yieldTotal === void 0) { yieldTotal = 0; }
    if (shareIncrease === void 0) { shareIncrease = 0; }
    $calculator
        .find("#token-count")
        .html(roundToDecimals(tokenCount, false, 0).toString());
    $calculator
        .find("#yield-2025")
        .html(roundToDecimals(yield2025, true).toString());
    $calculator
        .find("#pa-2025")
        .html(roundToDecimals(pa2025, false, 2).toString());
    $calculator
        .find("#yield-total")
        .html(roundToDecimals(yieldTotal, true).toString());
    $calculator
        .find("#share-increase")
        .html(roundToDecimals(shareIncrease, false, 2).toString());
};
var roundToDecimals = function (number, isCurrency, maximumDecimal) {
    if (maximumDecimal === void 0) { maximumDecimal = 2; }
    if (isNaN(number) || number === 0) {
        return isCurrency ? "0 Kč" : 0;
    }
    if (isCurrency) {
        return new Intl.NumberFormat("cs-Cz", {
            style: "currency",
            currency: "CZK",
        }).format(number);
    }
    return new Intl.NumberFormat("cs-Cz", {
        maximumFractionDigits: maximumDecimal,
    }).format(number);
};
$(".calculator").each(calculator);
